function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#607d8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.9 490.5c35-51.7 21.5-121.9-30.2-156.9-18.7-12.7-40.8-19.4-63.4-19.4v-28.3c0-15.6-12.7-28.3-28.3-28.3-15.6 0-28.3 12.7-28.3 28.3v28.3h-56.5v-28.3c0-15.6-12.7-28.3-28.3-28.3-15.6 0-28.3 12.7-28.3 28.3v28.3h-28.3c-15.6 0-28.3 12.7-28.3 28.3 0 15.6 12.7 28.3 28.3 28.3h28.3v282.6h-28.3c-15.6 0-28.3 12.7-28.3 28.3 0 15.6 12.7 28.3 28.3 28.3h28.3v28.3c0 15.6 12.7 28.3 28.3 28.3 15.6 0 28.3-12.7 28.3-28.3V710h56.5v28.3c0 15.6 12.7 28.3 28.3 28.3 15.6 0 28.3-12.7 28.3-28.3V710h56.5c62.3.2 112.9-50.2 113-112.5.1-48.3-30.4-91.3-75.9-107zM436.2 370.7h113c31.2 0 56.5 25.3 56.5 56.5s-25.3 56.5-56.5 56.5h-113v-113zm169.6 282.6H436.2v-113h169.6c31.2 0 56.5 25.3 56.5 56.5s-25.3 56.5-56.5 56.5z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.d1db7dec6b6ad7812f684ca621400405.svg";
export { ForwardRef as ReactComponent };